var React = require('react');

function Car (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M45.6045 8.66602H19.3953L14.1692 13.8922L10.1692 25.8922L5.83325 30.2281V49.9994H9.83325V55.3327H15.1666V49.9994H49.8333V55.3327H55.1666V49.9994H59.1666V30.2281L54.8307 25.8922L50.8307 13.8922L45.6045 8.66602ZM18.8307 16.7732L21.6045 13.9993H43.3954L46.1692 16.7732L48.8001 24.666H16.1997L18.8307 16.7732ZM13.6045 29.9993L11.1666 32.4373V44.666H53.8333V32.4373L51.3954 29.9993H13.6045Z","fill":"black"}));
}

Car.defaultProps = {"width":"65","height":"64","viewBox":"0 0 65 64","fill":"none"};

module.exports = Car;

Car.default = Car;
